import { Tooltip } from '@snack-uikit/tooltip';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function Erid(_ref) {
  var tip = _ref.tip,
    className = _ref.className,
    appearance = _ref.appearance;
  return /*#__PURE__*/_jsx(Tooltip, {
    triggerClassName: className,
    tip: tip,
    children: /*#__PURE__*/_jsx("span", {
      "data-appearance": appearance,
      className: styles.root
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: 0,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.label,
        children: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430"
      })
    })
  });
}